import { userService } from '../_services';
export const tellAFriendAction = (req) => {
    return userService.tellAFriend(req);
}